<template>
  <DataTable :headers="headers" :path="path" :properties="properties" :filterPath="filterPath" filter ref="datatable">
    <span slot="after-filters">
      <v-tooltip bottom>
        <v-btn slot="activator" icon @click="downloadExcel" flat>
          <v-icon color="primary">far fa-file-excel</v-icon>
        </v-btn>
        <span>Descargar XLS</span>
      </v-tooltip>
    </span>
  </DataTable>
</template>

<script>
import DataTable from '../../../common/ui/DataTable'
import { downloadFileMixin } from '../../../mixins/downloadFileMixin'

export default {
  mixins: [downloadFileMixin],

  components: {
    DataTable
  },

  data () {
    return {
      headers: [
        { text: 'Club', value: 'club', sortable: false, align: 'left', filterField: true },
        { text: 'Cargo', value: 'people', sortable: false, align: 'left', filterField: true },
        { text: 'Apellido', sortable: false, align: 'left' },
        { text: 'Nombre', sortable: false, align: 'left' },
        { text: 'Teléfono', sortable: false, align: 'left' },
        { text: 'Email', value: 'read', sortable: false, align: 'left' },
        { text: 'Última actualización', sortable: false, align: 'left' }
      ],
      properties: ['club', 'charge', 'lastName', 'firstName', 'phone', 'email', 'modified'],
      path: 'people/list',
      filterPath: 'filters/people'
    }
  },

  methods: {
    getExcelPath () {
      return 'people/xls' + '?' + this.$refs.datatable.getFilteringPath().substring(1)
    },
    getFilenamePrefix () {
      return 'personas'
    }
  }
}
</script>
